import * as borogove from "borogove";
import CallMissed from "@mui/icons-material/CallMissed";
import CallMade from "@mui/icons-material/CallMade";
import CallReceived from "@mui/icons-material/CallReceived";

export const CallMessage = ({ m }: { m: borogove.ChatMessage }) => {
	const missedCall = m.callStatus() === "retract";
	const duration = m.callDuration();
	return (
		<div className="call">
			{missedCall && <CallMissed />}
			{!missedCall && m.isIncoming() && <CallReceived />}
			{!missedCall && !m.isIncoming() && <CallMade />}
			{duration && [
				"(",
				<time
					key="callDuration"
					dateTime={"PT0H" + duration.replace(/:/, "M") + "S"}
				>
					{duration}
				</time>,
				") · ",
			]}
			<time dateTime={m.timestamp}>
				{new Date(m.timestamp).toLocaleString([], { timeStyle: "short" })}
			</time>
		</div>
	);
};
